import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {LoginTypeStep} from '@components/login/step/LoginTypeStep';
import {PasswordLoginStep} from '@components/login/step/PasswordLoginStep';
import {LoginType, LoginTypeResponse} from 'stores/AuthSource';
import {SamlStep} from '@components/login/step/SamlStep';
import {LoginSupport} from 'components/LoginSupport';

interface Coach360LoginProps {
  loadingAuth: boolean;
  // Things exposed beyond this point are for unit tests
  username?: string;
  loginTypeResponse?: LoginTypeResponse;
}

export const Coach360Login: React.FC<Coach360LoginProps> = props => {
  const [username, setUsername] = useState<string>(props.username ?? '');
  const [loginTypeResponse, setLoginTypeResponse] = useState<LoginTypeResponse | null>(
    props.loginTypeResponse ?? null
  );

  const css = useStyles();

  // Step flow
  function chooseStep(): JSX.Element {
    switch (loginTypeResponse?.loginMethod) {
      case LoginType.PASSWORD:
        return (
          <PasswordLoginStep username={username} setLoginTypeResponse={setLoginTypeResponse} />
        );
      case LoginType.GUM:
      case LoginType.SAML:
        return (
          <SamlStep
            samlName={loginTypeResponse.samlName}
            tenantId={loginTypeResponse.tenantId}></SamlStep>
        );
      default:
        return (
          <LoginTypeStep setLoginTypeResponse={setLoginTypeResponse} setUsername={setUsername} />
        );
    }
  }

  return (
    <>
      <div className={css.loginSidebar}>{chooseStep()}</div>
      <div className={css.supportParent}>
        <LoginSupport />
      </div>
    </>
  );
};

const useStyles = makeStyles(() => ({
  supportParent: {
    display: 'flex',
    justifyContent: 'right',
    width: '100%',
  },
  button: {
    height: 42,
  },
  input: {
    marginBottom: 35,
  },
  loginForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  loginSidebar: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 30,
    boxSizing: 'border-box',
  },
  controls: {
    padding: '0 20px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  checkboxLabel: {
    marginLeft: 5,
  },
  loadingSpinner: {
    marginRight: 5,
    '& *': {
      strokeWidth: 8,
    },
  },
}));
